import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Dropdown from "components/forms/Dropdown";
import SelectionItem from "components/forms/SelectionItem";
import DropdownSelection from "components/forms/DropdownSelection";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";

import blockIcon from "assets/img/icons/icons8-unavailable.svg";

const SetAutoresponder = styled.div`
  min-height: 300px;

  display: flex;
  flex-direction: column;
`;

const SetAutoresponderText = styled.div`
  margin-top: 50px;

  line-height: 130%;
`;

const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const SelectedItem = styled.div`
  font-family: "Arial", sans-serif;

  display: flex;
  align-items: center;
  gap: 6px;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const Warning = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const ManageAutoresponderText = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  line-height: 130%;
`;

const ManageButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
`;

const NoResponder = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN_XLARGE};
  margin-bottom: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  align-items: center;
  gap: 15px;
`;

const NoResponderIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResponderText = styled.div`
  text-align: left;
`;

export default ({
  data,
  selectionOpened,
  selectedResponder,
  toggleSelection,
  setAutoresponder,
  setAutoresponderLoading,
  onSelectOption,
  errorMessage,
  listId,
}) => {
  const selectionRef = useRef();
  const dropdownRef = useRef();
  const navigate = useNavigate();

  function useSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !dropdownRef.current.contains(event.target)
        ) {
          toggleSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useSelectionOutsideClick(selectionRef);

  const list = data.responderList.map((responder) => {
    return (
      <SelectionItem onClick={() => onSelectOption(responder.id)}>
        {responder.name}
      </SelectionItem>
    );
  });

  const selectedLabel = selectedResponder
    ? selectedResponder.name
    : "Not selected";

  return (
    <SetAutoresponder>
      <SetAutoresponderText>
        Connect the mailing list to the autoresponder and automatically send
        emails to your leads.
      </SetAutoresponderText>
      {list.length > 0 && (
        <DropdownWrap>
          <Dropdown onClick={toggleSelection} dropdownRef={dropdownRef}>
            <SelectedItem>{selectedLabel}</SelectedItem>
          </Dropdown>
          {selectionOpened && (
            <DropdownSelection
              width="290px"
              top="48px"
              selectionRef={selectionRef}
              maxHeight="170px"
            >
              {list}
            </DropdownSelection>
          )}
          <ButtonWrap>
            <ButtonPrimary
              onClick={setAutoresponder}
              disabled={setAutoresponderLoading}
            >
              Save
            </ButtonPrimary>
          </ButtonWrap>
          {errorMessage && <Warning>{errorMessage}</Warning>}
        </DropdownWrap>
      )}
      {list.length === 0 && (
        <NoResponder>
          <NoResponderIcon>
            <img src={blockIcon} style={{ width: "100%" }} />
          </NoResponderIcon>
          <NoResponderText>
            You don’t have any autoresponders yet.
          </NoResponderText>
        </NoResponder>
      )}
      <ManageAutoresponderText>
        Create a new autoresponder by clicking the Manage Autoresponders button.
      </ManageAutoresponderText>
      <ManageButtonWrap>
        <ButtonPrimarySmall
          onClick={() =>
            navigate(`/autoresponders?from=mailing-list&listId=${listId}`)
          }
        >
          Manage Autoresponders
        </ButtonPrimarySmall>
      </ManageButtonWrap>
    </SetAutoresponder>
  );
};
